import {useInfiniteQuery} from "react-query";

import {getAuthorizationHeader} from "../../../models/admin-session/selectors";
import {
  pccApi,
  handlePccRequestLimitReached,
} from "../../../services/PccService";
import {ACTIVITIES_LOG_QUERY, ACTIVITY_LOG_PAGE_SIZE} from "./constants";

export const useFetchActivitiesLog = (facilityId: string) => {
  return useInfiniteQuery(
    ACTIVITIES_LOG_QUERY,
    async ({pageParam = 0}) => {
      const {data} = await pccApi.getActivityLogRecordsUsingGET(
        facilityId,
        getAuthorizationHeader(),
        undefined,
        pageParam,
        ACTIVITY_LOG_PAGE_SIZE,
      );
      return data;
    },
    {
      refetchOnMount: "always",
      onError: error => handlePccRequestLimitReached(error),
      enabled: !!facilityId,
      getNextPageParam: (_, allPages) => allPages.length,
    },
  );
};
